export default __webpack_public_path__ + "static/media/zvet-colored.7e626c24.webp";